import $ from 'jquery'
import * as project from './functions'
import './polyfill'

window.onload = () => {
  project.lazyLoad()
  project.smoothScroll()
  project.menuOverlay()
  project.setupModalVideo()
  project.navMenu()
  project.setupJqueryModal()

  if ($('.slider-init').length > 0) {
    $('.slider-init').each(function() {
      project.setupSlideshow($(this), $(this).data('slick'), $(this).data('slides'))
    })
  }

  const bodyClasses = $('body').attr("class").split(/\s+/)

  $.each(bodyClasses, function(key, value) {
    switch(value) {
      case "home":
        break
      default:
        $('#loader').delay(2500).fadeOut(500)
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/main.js